import { useTypingIndicatorStyles } from './TypingIndicator.styles';

const TypingIndicator = () => {
  const classes = useTypingIndicatorStyles();

  return (
    <div className={classes.typingIndicator} aria-label="En train d'écrire">
      <span>•</span>
      <span>•</span>
      <span>•</span>
    </div>
  );
};

export default TypingIndicator;
